import React from "react";

import { Button } from "@shared/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { PAGE_SIZE } from "@shared/utils/constants";
import { Edit } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useUpdateSOManually } from "../../../hooks";

export const ScheduleQuickActionsSidebar: React.FC<{ data: any }> = ({
  data,
}) => {
  const updateSOManually = useUpdateSOManually(1, PAGE_SIZE);
  const navigate = useNavigate();
  return (
    <Card className="h-fit">
      <CardHeader>
        <CardTitle className="page-title">Schedule Actions</CardTitle>
        <p className="page-subtitle mb-2">Common schedule management tasks</p>
      </CardHeader>
      <CardContent className="space-y-3">
        <Button
          variant="outline"
          className="w-full justify-start"
          tooltip={
            "Modify schedule details such as frequency, assets, or triggers."
          }
          onClick={() => navigate(`/ax/service-order/schedule/edit/${data.id}`)}
          tooltipPosition="left"
        >
          <Edit className="h-4 w-4 mr-2" />
          Edit Schedule
        </Button>
        {/* <Button
          variant="outline"
          className="w-full justify-start"
          onClick={() =>
            updateSOManually.mutateAsync({
              id: data.id,
              executionDate: new Date().toISOString(),
              triggerType: 2,
            })
          }
          tooltip={
            "Create a new service order outside of the regular schedule run, useful for ad-hoc tasks."
          }
          tooltipPosition="left"
        >
          <Play className="h-4 w-4 mr-2" />
          Generate SO Manually
        </Button> */}
        {/* Removed for now will need after */}
      </CardContent>
    </Card>
  );
};
